module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Project presentation","subtitle":"8th November, 10AM (EET)","paragraphs":["Zoom","Deividas Varabauskas \\nSun Investment Group CEO"],"register":"Register"},"lt":{"title":"Projekto pristatymas","subtitle":"Lapkričio 7 d. 10:00","paragraphs":["Zoom platformoje","Deividas Varabauskas \\n„Sun Investment Group“ CEO"],"register":"Registruotis"}}')
  delete Component.options._Ctor
}
